import 'react-toastify/dist/ReactToastify.css';
import './style/index.scss'
import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from "@material-tailwind/react";
import LoadingPage from "./components/general/LoadingPage";
import {BrowserRouter} from "react-router-dom";
import CustomToastContainer from "./components/general/CustomToast";
import {I18nextProvider} from "react-i18next";
import i18next from "./translations/index";
import App from "./App";
import {QueryClientProvider} from "@tanstack/react-query";
import queryClient from "./services/configuration/queryClient";
import {SnackbarProvider} from "notistack";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
            <ThemeProvider>
                <I18nextProvider i18n={i18next}>
                    <SnackbarProvider
                        classes={{
                            containerRoot: 'snackbar-container'
                        }}
                        maxSnack={6}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <CustomToastContainer/>
                        <Suspense fallback={<LoadingPage className={'bg-header min-h-[100vh]'} logo={true}/>}>
                            <App />
                        </Suspense>
                    </SnackbarProvider>
                </I18nextProvider>
             </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
);
